import { Outlet, useLocation } from 'react-router-dom';
import { RedirectWithReturnLink, useSession } from 'context';

interface Props {
  redirectUrl: string;
}

export const ProtectedRoute = ({ redirectUrl }: Props) => {
  const session = useSession();
  const location = useLocation();

  if (!session) {
    return <RedirectWithReturnLink to={`${redirectUrl}${location.search}`} />;
  }

  return <Outlet />;
};
